export default __webpack_public_path__ + "static/media/VerticalResizeInFigure.0f39d8ba.gif";